"use client";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import Image from "next/image";
import { UserNav } from "@/components/user-nav";
import { RequestIndicator } from "@/components/request-indicator";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

const navLinks = [
  { title: "Accueil", url: "/" },
  { title: "Films", url: "/library?type=movie" },
  { title: "Séries", url: "/library?type=tv" },
  { title: "Animes", url: "/library?type=anime" },
  { title: "Découvrir", url: "/requests" },
];

export function TopNav() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [scrolled, setScrolled] = useState(false);

  const isActive = (url: string) => {
    const [path, query] = url.split('?');
    if (path === '/') return pathname === '/';
    if (!query) return pathname.startsWith(path);
    const params = new URLSearchParams(query);
    return pathname === path && [...params.entries()].every(
      ([k, v]) => searchParams.get(k) === v
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 flex h-16 items-center px-6 lg:px-10 transition-all duration-300",
      scrolled 
        ? "bg-background/70 backdrop-blur-xl border-b border-white/5 shadow-sm" 
        : "bg-transparent"
    )}>
      <div className="flex w-full items-center">
        
        {/* Left Side: Navigation Links */}
        <div className="flex-1 flex items-center">
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link 
                key={link.url} 
                href={link.url}
                className={cn(
                  "text-xs font-semibold tracking-tight transition-colors hover:text-white",
                  isActive(link.url) ? "text-white" : "text-white/80"
                )}
              >
                {link.title}
              </Link>
            ))}
          </nav>
        </div>

        {/* Center: Logo */}
        <div className="absolute left-1/2 -translate-x-1/2">
          <Link href="/" className="flex items-center group">
            <Image 
              src="/big_white_logo_osmose.png" 
              alt="Osmose" 
              width={120} 
              height={36} 
              className="h-auto w-auto max-h-9 object-contain"
              priority
            />
          </Link>
        </div>

        {/* Right Side: User Profile */}
        <div className="flex-1 flex items-center justify-end gap-4">
          <RequestIndicator />
          <UserNav />
        </div>
      </div>
    </header>
  );
}
